import { Link } from 'react-router-dom';
import StatusPage from './StatusPage.jsx';
import { LOGIN_ROUTE } from '../../config/menuData.js';

/** 401 — not authenticated. Prompts the visitor to sign in. */
export default function Unauthorized401() {
  return (
    <StatusPage
      code="401"
      title="You need to sign in"
      message="This page is only available to signed-in users. Sign in to continue, then we'll bring you back here."
      icon="fa fa-user-lock"
      tone="warning"
      actions={
        <Link className="btn btn-primary" to={LOGIN_ROUTE}>
          <i className="fa fa-sign-in-alt me-2" aria-hidden="true" />
          Log in
        </Link>
      }
    />
  );
}
